var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { AutoCompleteConfig } from './autocomplete.config';
var AutocompleteComponent = (function () {
    function AutocompleteComponent(myElement) {
        this.onItemSelected = new EventEmitter(false);
        this.onDelSelected = new EventEmitter(false);
        this.idDisabled = false;
        this.query = '';
        this.filteredList = [];
        this.elementRef = myElement;
    }
    AutocompleteComponent.prototype.filter = function () {
        var _this = this;
        this.selectedItem = null;
        if (this.query !== "" && this.query.length >= this.config.suggestFromCharNumber) {
            var queryPalabras_1 = this.quitaacentos(this.query).split(" ");
            this.filteredList = this.config.dataSource.filter(function (item) {
                var texto = _this.quitaacentos(item[_this.config.dataValue]);
                // Verifica que todas las palabras del query estén presentes en el texto del ítem
                return queryPalabras_1.every(function (palabra) { return texto.includes(palabra); });
            });
            if (this.filteredList.length === 0) {
                this.onDelSelected.emit(this.query);
            }
        }
        else {
            this.filteredList = [];
        }
    };
    AutocompleteComponent.prototype.onFocusOut = function () {
        if (this.selectedItem === null) {
            this.query = '';
            this.onDelSelected.emit(this.query);
        }
    };
    /*     quitaacentos(str: String) {
            var r=str.toLowerCase();
            r = r.replace(new RegExp(/\s/g),"");
            r = r.replace(new RegExp(/[àáâãäå]/g),"a");
            r = r.replace(new RegExp(/[èéêë]/g),"e");
            r = r.replace(new RegExp(/[ìíîï]/g),"i");
            r = r.replace(new RegExp(/ñ/g),"n");
            r = r.replace(new RegExp(/[òóôõö]/g),"o");
            r = r.replace(new RegExp(/[ùúûü]/g),"u");
                        
            return r;
        } */
    AutocompleteComponent.prototype.quitaacentos = function (str) {
        return str
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/[-_\.]+/g, " ")
            .replace(/\s+/g, " ")
            .trim();
    };
    AutocompleteComponent.prototype.addAll = function () {
        var _this = this;
        if (this.query !== "") {
            if (this.query.length >= this.config.suggestFromCharNumber)
                this.filteredList = this.config.dataSource.filter(function (item) { return item[_this.config.dataValue].toLowerCase().indexOf(_this.query.toLowerCase()) > -1; });
        }
        else {
            this.filteredList = this.config.dataSource;
        }
    };
    AutocompleteComponent.prototype.select = function (item) {
        this.selectedItem = item;
        this.query = this.selectedItem[this.config.dataValue];
        if (this.config.dataValue2 != '') {
            this.query = this.query + ' - ' + this.selectedItem[this.config.dataValue2];
        }
        this.filteredList = [];
        this.onItemSelected.emit(this.selectedItem);
    };
    AutocompleteComponent.prototype.clear = function () {
        this.query = '';
        this.selectedItem = null;
    };
    AutocompleteComponent.prototype.setDataSource = function (data) {
        this.config.dataSource = data;
    };
    AutocompleteComponent.prototype.handleClick = function (event) {
        var clickedComponent = event.target;
        var inside = false;
        do {
            if (clickedComponent === this.elementRef.nativeElement) {
                inside = true;
            }
            clickedComponent = clickedComponent.parentNode;
        } while (clickedComponent);
        if (!inside) {
            this.filteredList = [];
        }
    };
    return AutocompleteComponent;
}());
__decorate([
    Input(),
    __metadata("design:type", AutoCompleteConfig)
], AutocompleteComponent.prototype, "config", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], AutocompleteComponent.prototype, "onItemSelected", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], AutocompleteComponent.prototype, "onDelSelected", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], AutocompleteComponent.prototype, "idDisabled", void 0);
AutocompleteComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'autocomplete',
        host: {
            '(document:click)': 'handleClick($event)',
        },
        template: "\n\n            <div *ngIf=\"config !== null\">\n              <input id=\"_id\" type=\"text\" (focusout)=onFocusOut() [disabled]=\"idDisabled\" autocomplete=\"off\" class=\"form-control input-sm bginputs t-upper\" [(ngModel)]=query (keyup)=filter()>\n            </div>\n            <div class=\"suggestions zInd\" *ngIf=\"filteredList.length > 0\">\n                <div class=\"record-picker zInd hsvconcepto\">\n                    <ul *ngFor=\"let item of filteredList\" >\n                        <li>\n                            <label class=\"autoCcolor cursorHand\" (click)=\"select(item)\" title=\"{{item[this.config.dataValue] + (this.config.dataValue2 == '' ? '' : ' - ' + item[this.config.dataValue2])}}\" >{{item[this.config.dataValue] + (this.config.dataValue2 == '' ? '' : ' - ' + item[this.config.dataValue2])}}</label>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n\n        "
    }),
    __metadata("design:paramtypes", [ElementRef])
], AutocompleteComponent);
export { AutocompleteComponent };
//# sourceMappingURL=autocomplete.component.js.map